<template>
	<section>
		<div class="pc100W agileits" style="padding-top: 180px;min-height: 480px;">
			<div class="pcMaxW">
				<van-swipe class="swipeDescs" :autoplay="5000" lazy-render>
				  <van-swipe-item>
					  <div style="position: relative;">
						  <div class="bigTitle">聯繫我們</div>
						  <div class="desc">Contact Us</div>
				      </div>
				    </van-swipe-item>
					
				</van-swipe>
			</div>
		</div>
		<div class="imgContainer" style="background: #f4f4f4;">
			<section class="">
				<div class="pcMaxW p-5 container">
					<div class="dFlex alCenter jcBetween title mb-3">
						<h5 class="m-0 fw-normal">聯繫我們</h5>
					</div>
					<div class="texts">
						<p class="mb-2">公司：{{ $t('footer.company') }}</p>
						<p class="mb-2">郵箱：{{ $t('footer.email') }}</p>
						<p class="mb-2">電話：{{ $t('footer.tel') }}</p>
						<!-- <p class="mb-2">地址：{{ $t('footer.addr') }}</p> -->
					</div>
				</div>
			</section>
		</div>
	</section>
	
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	const banner = ref(require('@/assets/images/hongkong_000.png'))
</script>

<style lang="less" scoped>
	.imgContainer{
		overflow: hidden;padding: 60px 0;
		img{
			width: 100%;vertical-align: middle;border-radius: 23px;
		}
		.texts{
			font-size: 14px;color: #000;line-height: 30px;
		}
	}
</style>